module.exports = __webpack_public_path__ + "static/media/download.4a6c35b2.svg";